import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@/app/core/services/auth/auth.service';
import { environment } from '@/environments/environment';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // TEMP: bypass backend auth, but still require a "login" (token present) to access modules.
  if (environment.featureFlags?.bypassAuth) {
    return authService.isAuthenticated()
      ? true
      : router.createUrlTree([authService.getLoginRoute()]);
  }

  if (authService.isAuthenticated()) {
    const expiresAt = sessionStorage.getItem('expiresAt');
    if (expiresAt) {
      const expiryTime = new Date(expiresAt).getTime();
      if (!Number.isNaN(expiryTime) && expiryTime <= Date.now()) {
        authService.logout({ callApi: false, showToast: false });
        return router.createUrlTree([authService.getLoginRoute()]);
      }
    }
    return true;
  }

  authService.logout({ callApi: false, showToast: false });
  return router.createUrlTree([authService.getLoginRoute()]);
};
